import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  EventEmitter,
  Output,
} from "@angular/core";
import { NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { UserService } from "../../../services/userService/user.service";
import { Router } from "@angular/router";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { environment } from "../../../../environments/environment";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-sales-target-list",
  templateUrl: "./sales-target-list.component.html",
  styleUrls: ["./sales-target-list.component.css"],
})
export class SalesTargetListComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("showimport") showimport: any;
  @Output() clearEvent = new EventEmitter<void>();
  displayedColumns: string[] = [
    "BussinessVertical",
    "ProjectName",
    "InquiryName",
    "ReceivedDate",
    "CustomerName",
    "InquiryProbability",
    "Stage",
    "SalesEngineer",
    "QuotationEngineer",
    "QuotedValue",
    "ReportedValue",
    "ExpOrderDate",
    "Nov",
    "Dec",
    "Action",
  ];
  displayedTotalColumns: string[] = [
    "Total",
    "TotalValue",
    "TotalJan",
    "TotalFeb",
    "TotalMar",
    "TotalApr",
    "TotalMay",
    "TotalJun",
    "TotalJul",
    "TotalAug",
    "TotalSep",
    "TotalOct",
    "TotalNov",
    "TotalDec",
  ];
  Account: string;
  Finance: string;
  General: string;
  Sales: string;
  Service: string;
  TotalRow: any;
  FinanceYear: any;
  disableDate() {
    return false;
  }
  showinquiry: any = [];

  ranges: any = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Last 7 Days": [moment().subtract(6, "days"), moment()],
    "Last 30 Days": [moment().subtract(29, "days"), moment()],
    "This Month": [moment().startOf("month"), moment().endOf("month")],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  invalidDates: moment.Moment[] = [
    moment().add(2, "days"),
    moment().add(3, "days"),
    moment().add(5, "days"),
  ];

  isInvalidDate = (m: moment.Moment) => {
    return this.invalidDates.some((d) => d.isSame(m, "day"));
  };

  baseurl: string;
  permission: any;
  roleId: any;
  dataSource: MatTableDataSource<any>;
  TotalRecord: any;
  currentPage: any = 0;
  pageSize: any = 10;
  totalSize: any;
  showTable: boolean;
  searchword: any;
  modalRef: BsModalRef;
  data: unknown[];

  constructor(
    public formatter: NgbDateParserFormatter,
    private toastr: ToastrService,
    private router: Router,
    private UserService: UserService,
    private modalService: BsModalService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.baseurl = environment.api_url;
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
    let rId = localStorage.getItem("roleId");
    this.roleId = this.UserService.decryptData(rId);
    this.Account = localStorage.getItem("Account");
    this.Finance = localStorage.getItem("Finance");
    this.General = localStorage.getItem("General");
    this.Sales = localStorage.getItem("Sales");
    this.Service = localStorage.getItem("Service");
    if (this.permission.SalesTarget_View != 1 && this.roleId != 1) {
      this.toastr.error("You do not have permission");
      this.router.navigate(["/profile"]);
    }

    let data = {
      SearchWord: this.searchword,
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
      Export: "false",
    };
    this.spinner.show();
    this.UserService.SalesTargetList(data).subscribe(
      (response: any) => {
        if (response["result"] == "success") {
          this.spinner.hide();
          this.currentPage = 0;
          this.showinquiry = response["SalesTargetList"];
          this.TotalRow = response["TotalRow"];
          this.dataSource = new MatTableDataSource<any>(
            response["SalesTargetList"]
          );
          this.dataSource.paginator = this.paginator;
          this.TotalRecord = response["TotalRecord"];
          this.totalSize = response["TotalRecord"];
          this.iterator();
        } else if (response["result"] == "Failed") {
          this.toastr.error(response["Msg"]);
          this.spinner.hide();
        } else {
          this.toastr.error(response["Msg"] || response["Message"]);
          this.spinner.hide();
        }
      },
      (err) => {
        this.spinner.hide();
        if (err && (err.Msg || err.Message)) {
          this.toastr.error(err.Msg || err.Message);
        }
      }
    );
  }

  onSelectAll(items: any) {}
  onDeSelectAll(items: any) {}

  tr: any;
  date: any;
  onSubmit() {
    this.showTable = false;
    this.currentPage = 0;
    this.spinner.show();
    let data = {
      SearchWord: this.searchword,
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
      Export: "false",
    };
    this.spinner.show();
    this.UserService.SalesTargetList(data).subscribe(
      (res) => {
        if (res["result"] == "success") {
          this.spinner.hide();
          this.showTable = true;
          this.showinquiry = res["SalesTargetList"];
          this.dataSource = new MatTableDataSource<any>(res["SalesTargetList"]);
          this.TotalRow = res["TotalRow"];
          this.TotalRecord = res["TotalRecord"];
          this.tr = res["TotalRecord"];
          this.totalSize = this.TotalRecord;
          this.router.navigate(["/report/expected-orders"]);
        } else if (res["result"] == "Failed") {
          this.toastr.error(res["Msg"]);
          this.spinner.hide();
        } else {
          this.toastr.error(res["Msg"] || res["Message"]);
          this.spinner.hide();
        }
      },
      (err) => {
        this.spinner.hide();
        if (err && (err.Msg || err.Message)) {
          this.toastr.error(err.Msg || err.Message);
        }
      }
    );
  }

  public handlePage(e: any) {
    this.spinner.show();
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;
    this.iterator();
    let data = {
      SearchWord: this.searchword,
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
      Export: "false",
    };
    this.UserService.SalesTargetList(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TotalRow = res["TotalRow"];
        this.TotalRecord = res["TotalRecord"];
        this.totalSize = this.TotalRecord;
        this.spinner.hide();
        this.dataSource = new MatTableDataSource<any>(res["SalesTargetList"]);
      }
    });
  }

  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    const part = this.showinquiry.slice(start, end);
    this.dataSource = part;
  }

  show(id) {
    let encryptid = this.UserService.encryptData(id);
    encryptid = encryptid
      .toString()
      .replace("=", "Ar1t")
      .replace("/", "FGH")
      .replace("+", "THD");
    this.router.navigate(["/salestarget/edit-sales-target", encryptid]);
  }

  edit(fid) {
    let encryptid = this.UserService.encryptData(fid);
    encryptid = encryptid
      .toString()
      .replace(/=/g, "Ar1t")
      .replace(/\//g, "FGH")
      .replace(/\+/g, "THD");
    this.router.navigate(["/salestarget/edit-sales-target", encryptid]);
  }

  view(eid) {
    if (this.permission.SalesTarget_View == 1 || this.roleId == 1) {
      let encryptid = this.UserService.encryptData(eid);
      encryptid = encryptid
        .toString()
        .replace("=", "Ar1t")
        .replace("/", "FGH")
        .replace("+", "THD");
      this.router.navigate(["/salestarget/detail-sales-target", encryptid]);
    } else {
      this.toastr.error("Permission Denied !");
    }
  }

  applyFilter() {
    this.currentPage = 0;
    this.spinner.show();
    let data = {
      SearchWord: this.searchword,
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
      Export: "false",
    };
    this.UserService.SalesTargetList(data).subscribe(
      (res) => {
        if (res["result"] == "success") {
          this.TotalRow = res["TotalRow"];
          this.TotalRecord = res["TotalRecord"];
          this.totalSize = this.TotalRecord;
          this.spinner.hide();
          this.dataSource = new MatTableDataSource<any>(res["SalesTargetList"]);
        } else if (res["result"] == "Failed") {
          this.toastr.error(res["Msg"]);
          this.spinner.hide();
        } else {
          this.toastr.error(res["Msg"] || res["Message"]);
          this.spinner.hide();
        }
      },
      (err) => {
        this.spinner.hide();
        if (err && (err.Msg || err.Message)) {
          this.toastr.error(err.Msg || err.Message);
        }
      }
    );
  }

  clearUserData() {
    const previousValue = this.searchword;
    this.searchword = "";
    if (
      previousValue &&
      previousValue.length > 0 &&
      previousValue !== this.searchword
    ) {
      this.clearEvent.emit();
    }
  }

  ExportOpenModal(template: TemplateRef<any>, id) {
    this.FinanceYear = id;
    this.modalRef = this.modalService.show(template, {
      class: "modal-sm modal-dialog-centered",
      backdrop: "static",
      ignoreBackdropClick: true,
      keyboard: false,
    });
  }

  exportConfirm() {
    this.exportinquiry();
    this.modalRef.hide();
  }

  exportinquiry() {
    this.showTable = false;
    this.spinner.show();
    let data = {
      FinancialYear: this.FinanceYear,
      SearchWord: this.searchword,
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
      Export: "true",
    };
    this.spinner.show();
    this.UserService.GetSalesTargetDetailsByYear(data).subscribe(
      (res: any) => {
        if (res["result"] == "success") {
          this.spinner.hide();
          let exporturl = res["Data"];
          window.open(this.baseurl + "/" + exporturl);
        } else if (res["result"] == "Failed") {
          this.toastr.error(res["Msg"]);
          this.spinner.hide();
        } else {
          this.toastr.error(res["Msg"] || res["Message"]);
          this.spinner.hide();
        }
      },
      (err) => {
        this.spinner.hide();
        if (err && (err.Msg || err.Message)) {
          this.toastr.error(err.Msg || err.Message);
        }
      }
    );
  }

  decline() {
    this.modalRef.hide();
  }
}
